import { Component, OnInit, ViewChild, HostListener, } from '@angular/core';
import { Router } from '@angular/router';
// import { SidenavComponent } from './sidenav/sidenav.component';
import * as dicomParser from 'dicom-parser';
import * as Hammer from 'hammerjs';
import { ConfigService } from './services/config.service';

// declare const cornerstoneWADOImageLoader;
import * as cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader/dist/dynamic-import/cornerstoneWADOImageLoader.min.js';
import { TranslateService } from '@ngx-translate/core';
import { SidenavComponent } from './sidenav/sidenav.component';
import ZoomTool from '../assets/cornerstone/tools/ZoomTool';
import ProbeTool from '../assets/cornerstone/tools/ProbeTool';
import MagnifyTool from '../assets/cornerstone/tools/MagnifyTool';
import FreehandRoiTool from '../assets/cornerstone/tools/FreeHandRoiTool';
import EraserTool from '../assets/cornerstone/tools/EraserTool';
import CobbAngleTool from '../assets/cornerstone/tools/CobbAngleTool';
import ScaleOverlayTool from '../assets/cornerstone/tools/ScaleOverlayTool';
import MyArrowAnnotateTool from '../assets/cornerstone/tools/ArrowAnnotationTool';
import HLineTool from '../assets/cornerstone/tools/HLineTool';
import VLineTool from '../assets/cornerstone/tools/VLineTool';
import LineDrawTool from '../assets/cornerstone/tools/LineDrawTool';
import ParallelTool from '../assets/cornerstone/tools/ParallelTool';
import TextAnnotationTool from '../assets/cornerstone/tools/TextAnnotationTool';
import FreehandDrawTool from '../assets/cornerstone/tools/FreeHandDrawTool';
import EllipticalDrawTool from '../assets/cornerstone/tools/EllipticalDrawTool';
import ExternalAnnotationsTool from '../assets/cornerstone/tools/ExternalAnnotationsTool';
import { VerticalHeaderComponent } from './header/vertical-header/vertical-header.component';

declare const cornerstone: any;
declare const cornerstoneTools: any;
declare const cornerstoneMath: any;

const routesWithoutHeader = [
  '/acceso',
];

const routesWithoutNav = [
  '/acceso',
  '/visor',
  '/login',
  '/forgotpass',
  '/pacs',
  '/recoverpassword',
  '/ris',
  '/doctor-edit-report',
];

const routesWithSubmenu = [
  '/miPerfil',
  '/configuration'
]

const titlesByRoute = [
  { route: '/book-digital', title: 'Digital Dynamic Book', center: false },
  { route: '/informe-electronico2', title: 'Intelligent Medical Report 2', center: false },
  { route: '/informe-electronico', title: 'Intelligent Medical Report', center: false },
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  @ViewChild(VerticalHeaderComponent) verticalHeaderComponent!: VerticalHeaderComponent;
  @ViewChild(SidenavComponent) sideNav!: SidenavComponent;

  actualUrl: string = '';
  showHeader: boolean = false;
  showNav: boolean = false;

  constructor(
    private configService: ConfigService,
    public translate: TranslateService,
    public router: Router
  ) {
    translate.addLangs(['es', 'pt', 'fr', 'ca']);
    translate.setDefaultLang('es');

    const browserLang = translate.getBrowserLang();
    if (browserLang != null) {
      translate.use(browserLang.match(/es|pt|ca|cat|fr/) ? browserLang : 'es');
    }

    initCornerstone();
    initCornerstoneTools();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    //this.refreshHeader();
  }

  ngOnInit(): void {

    this.actualUrl = this.router.url;
    if (this.verticalHeaderComponent) {
      //this.refreshHeader();
      //this.verticalHeaderComponent.leftMargin = '0px';
    }
    setTimeout(() => {
      this.refreshNav();
    }, 0);
  }

  /*refreshHeader() {
    if (this.header) {
      this.showHeader = (routesWithoutHeader.findIndex(r => this.actualUrl.startsWith(r)) === -1);
      // this.showHeader = (window.innerWidth <= 991) ? false : true;
      if (this.showHeader) {
        document.getElementById('general-div')!.style.height = 'calc(100% - 70px)';
        const t = titlesByRoute.find(r => this.actualUrl.startsWith(r.route));
        this.header.rightText = t ? t.title : '';
        this.header.leftText = t ? '' : '';
        if (t && t.center) {
          this.header.center = true;
        } else {
          this.header.center = false;
        }
      } else {
        document.getElementById('general-div')!.style.height = '100%';
      }
      this.header.showHeader = this.showHeader;
    }
  }*/

  refreshNav() {
    this.showNav = (routesWithoutNav.findIndex(r => this.actualUrl.startsWith(r)) === -1);
    if (this.showNav) {
      this.sideNav.changeRoute(this.actualUrl);
      this.sideNav.showNav(this.actualUrl);
      if (routesWithSubmenu.findIndex(r => this.actualUrl.startsWith(r)) > -1) {
        this.sideNav.showSubnav = true;
      } else {
        this.sideNav.showSubnav = false;
      }
      this.sideNav.refreshNav();
    } else {
      this.sideNav.hideNav(this.actualUrl);
      if (this.verticalHeaderComponent) {
        this.showHeader = (routesWithoutHeader.findIndex(r => this.actualUrl.startsWith(r)) === -1);
        //this.verticalHeaderComponent.leftMargin = '0px';
      }
    }

  }

  changeOfRoutes() {
    this.actualUrl = this.router.url;
    console.log('this.actualUrl', this.actualUrl);

    //this.refreshHeader();
    this.refreshNav();
  }

  sidenavCollapsed(isCollapsed: any) {
    if (this.verticalHeaderComponent) {
      //this.verticalHeaderComponent.leftMargin = (isCollapsed) ? '55px' : '175px';
    }
  }

  test() {
    const root = document.body;
    root.style.setProperty('--mode', 'gray');
    root.style.setProperty('--primary', '#353638');
    root.style.setProperty('--secondary', '#464749');
    root.style.setProperty('--secondary', '#464749');
    root.style.setProperty('--scrollbar-color', '#555659');
    root.style.setProperty('--scrollbar-color-hover', '#555659');
    root.style.setProperty('--scrollbar-color-track', '#7E7F84');
    root.style.setProperty('--btn-primary-grad1', '#69696E');
    root.style.setProperty('--btn-primary-grad2', '#676D7D');
    root.style.setProperty('--card-grad1', '#555659');
    root.style.setProperty('--card-grad2', '#676D7D');
    root.style.setProperty('--line-color', '#353638');
    root.style.setProperty('--btn-primary-border', '#2D2D2D');
    root.style.setProperty('--input-background', '#464749');
  }
}

function initCornerstone() {
  // Inicializamos Cornerstone

  // @ts-ignore
  if (window && window.dicomParser) {
    // @ts-ignore
    dicomParser = window.dicomParser;
    // this.dicomParser = window.dicomParser;
  } else {
    console.error('ERROR loading DicomParser');
  }

  (cornerstoneWADOImageLoader as any).external.cornerstone = cornerstone; // inicializa WADO Image loader
  (cornerstoneWADOImageLoader as any).external.dicomParser = dicomParser;

  /* Configura headers personalizados para las peticiones de imágenes
  const token = localStorage.getItem('DBAuthTkn'); //carga del token
  console.log('Token para cargar en cornerstoneWADOImageLoader:', token);
  (cornerstoneWADOImageLoader as any).configure({
    headers: {
      'Auth-Token': token || ''
    },
    withCredentials: true
  });*/

  /* Configura headers personalizados para las peticiones de imágenes
  const token = localStorage.getItem('DBAuthTkn'); //carga del token
  console.log('Token cargado en cornerstoneWADOImageLoader:', token);
  (cornerstoneWADOImageLoader as any).configure({
    headers: {
      'Auth-Token': token || ''
    },
    withCredentials: true
  });*/

  // configura codecs y web workers
  (cornerstoneWADOImageLoader as any).webWorkerManager.initialize({
    webWorkerTaskPaths: [],
    taskConfiguration: {
      decodeTask: {
        initializeCodecsOnStartup: false,
        usePDFJS: false,
        strict: true,
      },
    },
    maxWebWorkers: navigator.hardwareConcurrency || 4,
    startWebWorkersOnDemand: true,
  });

  cornerstoneTools.external.cornerstone = cornerstone;
  cornerstoneTools.external.Hammer = Hammer;
  cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
  cornerstoneTools.init({ showSVGCursors: true, globalToolSyncEnabled: true });
  cornerstoneTools.enableLogger();

  cornerstoneTools.textStyle.setBackgroundColor('black');
  cornerstoneTools.textStyle.setFont(`16px Arial`);

  // cornerstoneTools.toolColors.setToolColor('#00eaff'); // turquesa
  // cornerstoneTools.toolColors.setToolColor('#FF0080'); // fucsia
  cornerstoneTools.toolColors.setToolColor('#88ff00'); // verde
  // cornerstoneTools.toolColors.setToolColor('#ff8000'); // naranja
  cornerstoneTools.toolStyle.setToolWidth(2);
}

function initCornerstoneTools() {
  cornerstoneTools.addTool(cornerstoneTools.WwwcTool);
  cornerstoneTools.addTool(cornerstoneTools.PanTool);
  cornerstoneTools.addTool(ZoomTool);
  // cornerstoneTools.addTool(cornerstoneTools.ZoomTool);
  cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool);
  cornerstoneTools.setToolActive('ZoomTouchPinch', { mouseButtonMask: 1 })
  cornerstoneTools.addTool(cornerstoneTools.PanMultiTouchTool);
  cornerstoneTools.setToolActive('PanMultiTouch', { mouseButtonMask: 1 })
  cornerstoneTools.addTool(cornerstoneTools.ZoomMouseWheelTool)
  cornerstoneTools.addTool(cornerstoneTools.StackScrollMouseWheelTool);

  cornerstoneTools.addTool(ProbeTool);
  cornerstoneTools.addTool(cornerstoneTools.LengthTool);
  cornerstoneTools.addTool(cornerstoneTools.AngleTool);
  cornerstoneTools.addTool(cornerstoneTools.EllipticalRoiTool);
  cornerstoneTools.addTool(cornerstoneTools.RectangleRoiTool);
  cornerstoneTools.addTool(cornerstoneTools.DragProbeTool);
  cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool);
  cornerstoneTools.addTool(cornerstoneTools.PanMultiTouchTool);
  cornerstoneTools.addTool(MagnifyTool);
  cornerstoneTools.addTool(cornerstoneTools.RotateTool);
  cornerstoneTools.addTool(FreehandRoiTool);
  cornerstoneTools.addTool(CobbAngleTool);
  cornerstoneTools.addTool(EraserTool);
  // cornerstoneTools.addTool(cornerstoneTools.EraserTool);
  cornerstoneTools.addTool(ScaleOverlayTool);
  cornerstoneTools.addTool(cornerstoneTools.BidirectionalTool);
  cornerstoneTools.addTool(cornerstoneTools.BrushTool);
  cornerstoneTools.addTool(MyArrowAnnotateTool);
  cornerstoneTools.addTool(HLineTool);
  cornerstoneTools.addTool(VLineTool);
  cornerstoneTools.addTool(LineDrawTool);
  cornerstoneTools.addTool(ParallelTool);
  cornerstoneTools.addTool(TextAnnotationTool);
  cornerstoneTools.addTool(FreehandDrawTool);
  cornerstoneTools.addTool(EllipticalDrawTool);
  cornerstoneTools.addTool(ExternalAnnotationsTool);
}